module.exports = "/v2/pages/dashboard/dist/f7efe2791bfecd778b388e15fcdd284e.svg";